export const NAME = 'pageHeader'

export const SET_LOGIN_MODAL_OPEN = `${NAME}/SET_LOGIN_MODAL_OPEN`

export const SET_LOGIN_MODAL_CLOSED = `${NAME}/SET_LOGIN_MODAL_CLOSED`

export const SET_LOGIN_MODAL_TYPE = `${NAME}/SET_LOGIN_MODAL_TYPE`
